export default class UserConfig {
    constructor(userId, administeredUserId, administeredUserIdentifier, userTimeZone, userTimeFormat, userDateFormat, userIdentifier, userType, administeredUserType, impersonatorUserId, preferredCurrency, userLevel, identityCountry) {
        this.userId = userId;
        this.administeredUserId = administeredUserId;
        this.administeredUserIdentifier = administeredUserIdentifier;
        this.userTimeZone = userTimeZone;
        this.userTimeFormat = userTimeFormat;
        this.userDateFormat = userDateFormat;
        this.userIdentifier = userIdentifier;
        this.userType = userType;
        this.administeredUserType = administeredUserType;
        this.impersonatorUserId = impersonatorUserId;
        this.preferredCurrency = preferredCurrency;
        this.userLevel = userLevel;
        this.identityCountry = identityCountry;
    }
    getUserId() {
        return this.userId;
    }
    getAdministerUserId() {
        return this.administeredUserId;
    }
    getAdministeredUserIdentifier() {
        return this.administeredUserIdentifier;
    }
    getUserTimeZone() {
        return this.userTimeZone;
    }
    getUserTimeFormat() {
        return this.userTimeFormat;
    }
    getUserDateFormat() {
        return this.userDateFormat;
    }
    getUserIdentifier() {
        return this.userIdentifier;
    }
    getUserType() {
        return this.userType;
    }
    getAdministeredUserType() {
        return this.administeredUserType;
    }
    getImpersonatorUserId() {
        return this.impersonatorUserId;
    }
    getPreferredCurrency() {
        return this.preferredCurrency;
    }
    getUserLevel() {
        return this.userLevel;
    }
    getIdentityCountry() {
        return this.identityCountry;
    }
}
